var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgData = function SvgData(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 1200"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1074 276.84c0 90.797-212.26 164.39-474.05 164.39S125.9 367.636 125.9 276.84c0-90.75 212.26-164.34 474.05-164.34S1074 186.094 1074 276.84M1074 923.29c0 77.484-202.78 164.21-474.05 164.21-271.31 0-474.05-86.719-474.05-164.21v-198.1c101.77 74.719 291.74 114.05 474.05 114.05S972.23 799.865 1074 725.19z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M600 764.26c-271.31 0-474.05-86.719-474.05-164.21v-197.9C227.67 476.869 417.69 516.24 600 516.24s372.28-39.375 474.05-114.09v197.9c0 77.484-202.78 164.21-474.05 164.21"
  })));
};
export default SvgData;